import React, { useContext, useEffect } from 'react';
import { fromLonLat } from 'ol/proj';
import MapContext from '../Map/MapContext';

const CenterMapOnCoordinates = ({ setCoordinatesToCenter, coordinatesToCenter }) => {
  const { map } = useContext(MapContext);

  useEffect(() => {
    if (!map || !coordinatesToCenter) return;  

    const transformedCoordinates = fromLonLat(coordinatesToCenter);

    console.log('Centro el mapa en:', transformedCoordinates);
    
    const view = map.getView();
    view.animate({
      center: transformedCoordinates,
      zoom: 18,  // 🔍 
      duration: 1000, // 1 segundo de animación
    });

  }, [coordinatesToCenter, map]);

  return null;
};

export default CenterMapOnCoordinates;
